export default "__VITE_ASSET__CzxYjAsV__"